import { createAction } from 'redux-act';
import { IAccessRules } from '../types/accessRules';

export const PUT_ACCESS_RULES = 'PUT_ACCESS_RULES';
const getPayload = (payload: any) => payload;

export const accessRulesAction = createAction();

export const putAccessRules = createAction<IAccessRules>(PUT_ACCESS_RULES, getPayload);
